import React, { useEffect, useState } from "react";
import MapComponent from "./Map";
import { useLocation } from "react-router-dom";

const SearchMap = (props) => {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState({});
  const getAllUrlParams = () => {
    const queryParams = new URLSearchParams(location.search);
    const allParams = {};
    for (const [key, value] of queryParams.entries()) {
      allParams[key] = value;
    }
    return allParams;
  };
  useEffect(() => {
    const params = getAllUrlParams();

    setQueryParams(params); // Update the state with the query parameters
  }, [location.search]); // Run when the URL changes
  // Check if there are no valid parameters
  const hasNoValidParams =
    Object.keys(queryParams).length === 0 ||
    Object.values(queryParams).every((val) => !val || val === "null");
  const { showMap } = props;
  // Don't render the bare-map view at all once the user has run a search —
  // the results page has its own embedded map already, and rendering this
  // one in addition leaves a stray satellite tile under the listing. The
  // previous implementation relied on a CSS `.hide` class to suppress it,
  // which wasn't actually hiding the element on the live layout.
  if (!showMap || !hasNoValidParams) return null;
  return (
    <div className="cstm_indx">
      <MapComponent
        setDrawnFeatures={props.setDrawnFeatures}
        drawnFeatures={props.drawnFeatures}
        handleSearchClick={props.handleSearchClick}
        page="search"
        Maptoggle={props.Maptoggle}
      />
    </div>
  );
};

export default SearchMap;
